export enum ModalView {
  Default = 'default',
  Tabs = 'tabs',
}

export interface ModalDefaultProps {
  show?: boolean
  title?: string | null
  description?: string | null
  loading?: boolean
  view?: ModalView
  hidden?: boolean
  className?: string
  overlayClassName?: string
  isCloseButton?: boolean
  isBackButton?: boolean
}
